import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
// Should pass 'desc' if sorting is needed in descending order

@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {
    transform(value, args: string[]): any {
        let keys = [];
        _.forEach(value, (item)=> {
            keys.push({ key: Object.keys(item)[0], value: Object.values(item)[0]});
        });
        return keys;
    }
}


// WEBPACK FOOTER //
// ./src/app/rFF/pipes/keys.pipe.ts